import React from 'react';
import { 
  HeroSection,
  ServicesGridSection,
  ProcessSection,
  WhyChooseUsSection,
  CTASection,
  SEO
} from '../components';

const Services = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Digital Marketing & IT Services",
    "description": "Comprehensive digital solutions including web development, SEO, social media marketing, and brand identity design.",
    "provider": {
      "@type": "Organization",
      "name": "GrowthVibe",
      "url": "https://growthvibe.com"
    },
    "serviceType": [
      "Web Development",
      "Digital Marketing", 
      "SEO Services",
      "Social Media Marketing",
      "Brand Identity Design",
      "E-commerce Solutions"
    ],
    "areaServed": {
      "@type": "Country",
      "name": "India"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Digital Marketing Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Web Development",
            "description": "Custom website development and e-commerce solutions"
          }
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "SEO Services",
            "description": "Search engine optimization to improve online visibility"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service", 
            "name": "Social Media Marketing",
            "description": "Strategic social media campaigns and management"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Our Services - Digital Marketing & Web Development | GrowthVibe"
        description="Comprehensive digital solutions including web development, SEO, social media marketing, and brand identity design. Tailored services to drive your business growth."
        keywords="digital marketing services, web development, SEO services, social media marketing, brand design, e-commerce solutions, IT services, GrowthVibe"
        url="/services"
        structuredData={structuredData}
      />
      <div className="services-page">
        {/* Hero Section */}
      <HeroSection
        title="Our Services – Tailored to Drive Growth"
        description="Comprehensive digital solutions designed to accelerate your business growth and maximize your online presence."
        showGradient={true}
        heroImage="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
        heroImageAlt="Digital Services and Technology Solutions"
        layout="default"
      />

      {/* Services Grid */}
      <ServicesGridSection />

      {/* Process Section */}
      <ProcessSection />

      {/* Why Choose Us */}
      <WhyChooseUsSection />

      {/* CTA Section */}
      <CTASection 
        title="Ready to Get Started?"
        description="Let's discuss how our services can help transform your business and drive sustainable growth."
        primaryButtonText="Get Free Consultation"
        primaryButtonLink="/contact"
        secondaryButtonText="Learn More About Us"
        secondaryButtonLink="/about"
      />
      </div>
    </>
  );
};

export default Services;
